import { footerNav } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-accent-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#top" className="mb-4 flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-accent-400 text-xl text-white">
                <i className="ri-heart-3-fill"></i>
              </span>
              <span className="font-display text-2xl text-foreground-900">吃瓜糖心</span>
            </a>
            <p className="max-w-sm text-sm leading-relaxed text-foreground-700">
              吃瓜糖心汇集高能甜料与甜到齁的瞬间，用轻松有趣的甜蜜内容，为你的生活补充今日份糖分与好心情。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#top" aria-label="微信" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-lg text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-wechat-fill"></i>
              </a>
              <a href="#top" aria-label="微博" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-lg text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="#top" aria-label="小红书" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-lg text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-account-circle-fill"></i>
              </a>
              <a href="#top" aria-label="抖音" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-lg text-foreground-700 transition-colors hover:text-primary-600">
                <i className="ri-music-2-fill"></i>
              </a>
            </div>
          </div>

          {footerNav.map((col) => (
            <div key={col.title}>
              <h3 className="mb-4 text-sm font-semibold text-foreground-900">{col.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-accent-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-center text-xs text-foreground-600 sm:flex-row md:px-6">
          <span>© {new Date().getFullYear()} 吃瓜糖心 · 高甜瓜料与甜蜜爆料内容站</span>
          <span className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500"></i>
            把糖分扩散，把快乐留下
          </span>
        </div>
      </div>
    </footer>
  );
}